<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="prjDialogVisible" title="项目" width="600px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-input v-model="keyword" placeholder="请输入项目名称" style="width: 200px" size="small" clearable
          @keyup.enter.native="queryPrjList(1)">
          <i slot="prefix" class="el-input__icon el-icon-search" />
        </el-input>
      </div>
      <el-table ref="multipleTable"
        :key="tabKey"
        :data="prjList"
        border
        tooltip-effect="dark" style="width: 100%;min-height:550px" height="calc(100% - 70px)" row-key="prjId" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" reserve-selection>
        </el-table-column>
        <el-table-column label="项目名称" prop="originalPrjName" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="项目编号" prop="prjCode" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="项目总负责人" prop="prjLeaderName" align="center" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div style="text-align: right;">
        <el-pagination v-if="page.totalCount > 0" :current-page.sync="page.pageNo" :page-size="page.pageSize"
          :layout="page.pageLayout" :total="page.totalCount" size="small" background
          @current-change="prjSelectData" @size-change="handleSizeChange" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="prjDialogVisible = false">取 消</el-button>
        <el-button v-preventReClick size="small" type="primary" @click="commitSelectPrj()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import XtDesignService from "@/CommonDP/service/XtDesign-service";
export default {
  props: {
    selectPrjList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      prjDialogVisible: false,
      selectionData: [],
      prjList: [],
      tabKey: 1,
      keyword: '',
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total,sizes,prev, pager, next,jumper" // 分页组件
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  methods: {
    show() {
      this.keyword = '';
      this.selectionData = [];
      this.prjList = [];
      this.prjDialogVisible = true;
      this.tabKey++;
      this.page.pageNo = 1;
      this.page.totalCount = 0;
      this.selectionData = JSON.parse(JSON.stringify(this.selectPrjList));
      this.queryPrjList(1);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.queryPrjList(1);
    },
    prjSelectData(val) {
      this.queryPrjList(val);
    },
    async queryPrjList(val) {
      const {
        page: { pageSize }
      } = this;
      const params = {
        enterpriseId: this.enterpriseId,
        pageNum: val,
        pageSize: pageSize,
        keyword: this.keyword
      };
      const res = await XtDesignService.getProjectsByUserIdWithPage(params);
      this.page.totalCount = res.totalCount;
      this.prjList = res.data || [];
      const list = [];
      for (let s = 0; s < this.selectionData.length; s++) {
        for (let g = 0; g < this.prjList.length; g++) {
          if (this.selectionData[s].prjId === this.prjList[g].prjId) {
            list.push(this.prjList[g]);
          }
        }
      }
      this.toggleSelection(list);
    },
    toggleSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },

    commitSelectPrj() {
      if (!this.selectionData.length) {
        this.$warn("请勾选项目");
        return;
      }
      this.$emit("callback", this.selectionData);
      this.prjDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    }
  }
};
</script>

<style scoped lang="scss"></style>
